// extracted by mini-css-extract-plugin
export default {"columns":"Columns_columns__VKH5E","spaceBetween":"Columns_spaceBetween__iyqEJ"};